export const COMPETENCIES = [
  { key: "core_skills", title: "Core Riding Skills", desc: "Operates the motorcycle smoothly, safely and with appropriate finesse." },
  { key: "corners_bends", title: "Corners and Bends", desc: "Uses appropriate techniques to negotiate corners and bends safely and legally." },
  { key: "junctions_roundabouts", title: "Junctions and Roundabouts", desc: "Approaches, enters, negotiates and leaves junctions and roundabouts safely." },
  { key: "overtaking", title: "Overtaking", desc: "Correct positioning, planning and execution of safe and legal overtakes." },
  { key: "motorways_dual", title: "Motorways and Dual Carriageways", desc: "Understands the differences between road types and manages the associated hazards." },
  { key: "slow_riding", title: "Slow Riding", desc: "Controls the motorcycle safely and legally in traffic and slow-moving conditions." },
  { key: "powders", title: "POWDERS / Bike Check", desc: "Completes the POWDERS bike check WITHOUT prompt from the assessor (may be done at the end)." },
];

export const COMP_TITLE = Object.fromEntries(COMPETENCIES.map((c) => [c.key, c.title]));

export const ROADS = [
  { key: "motorway", label: "Motorways" },
  { key: "dual", label: "Dual carriageways" },
  { key: "rural", label: "Rural roads" },
  { key: "urban", label: "Town & urban centres" },
];

export const OUTCOMES = {
  pass: { label: "Successful", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  unsuccessful: { label: "Unsuccessful", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
  referred: { label: "Refer to Trustees", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  cancelled: { label: "Cancelled (eyesight)", cls: "bg-zinc-500/20 text-zinc-300 border-zinc-500/40" },
};

export const STATUSES = {
  current: { label: "Current", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  due_soon: { label: "Due soon", cls: "bg-yellow-400/15 text-yellow-300 border-yellow-400/40" },
  overdue: { label: "Overdue", cls: "bg-rose-600/20 text-rose-400 border-rose-500/40" },
  awaiting: { label: "Awaiting assessment", cls: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  unsuccessful: { label: "Unsuccessful", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
  cancelled: { label: "Cancelled (eyesight)", cls: "bg-zinc-500/20 text-zinc-300 border-zinc-500/40" },
  referred: { label: "With Trustees", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  discontinued: { label: "Not continuing", cls: "bg-zinc-600/30 text-zinc-400 border-zinc-500/40" },
};

export const ROLES = {
  admin: "Admin / Lead Assessor",
  assessor: "Assessor (Observer)",
  trustee: "Trustee",
  rider: "Rider",
  fleet_manager: "Fleet Manager",
  controller: "Controller (DCM)",
  hospital: "Hospital portal user",
};

export const homeFor = (u) => {
  const p = u.permissions || {};
  if (u.role === "hospital") return "/hospital";
  if (u.role === "rider") return "/my";
  if (u.role === "trustee" && p.reports) return "/trustees";
  if (u.role === "controller" && p.control) return "/control";
  if (u.role === "fleet_manager" && p.fleet) return "/fleet";
  return p.dashboard ? "/dashboard" : p.control ? "/control" : p.rota ? "/rota" : "/account";
};

export const APPEAL_STATUS = {
  open: "Open",
  under_review: "Under review",
  retest_scheduled: "Re-test scheduled",
  upheld: "Upheld",
  dismissed: "Dismissed",
  resolved: "Resolved",
};

export const ANSWER_LABEL = { ok: "OK", fault: "Fault", not_done: "Not done", yes: "Yes", no: "No" };

export const OFF_KINDS = { repair: "Under repair", maintenance: "In for maintenance", other: "Off road" };
export const offLabel = (b) => OFF_KINDS[b.off_road_kind || "other"].toUpperCase();
export const offDays = (b) => (b.status === "off_road" && b.status_changed_at ? Math.floor((Date.now() - Date.parse(b.status_changed_at)) / 86400000) : 0);
export const repairOverdue = (b) => b.status === "off_road" && offDays(b) > 7;
export const backLabel = (b) => (b.status === "off_road" ? (b.expected_back ? `Expected back ${new Date(b.expected_back).toLocaleDateString("en-GB", { day: "2-digit", month: "short" })}` : "Return date not set") : "");
export const fmtDateTime = (d) => (d ? new Date(d).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—");

export const fmtSize = (n) => (n > 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
